import {useDispatch, useSelector} from "react-redux";


import Table2Member from "../../images/1-table-2-chair.png";
import Table4Member from "../../images/1-table-4-chair.png";
import Table6Member from "../../images/1-table-6-chair.png";
import Table8Member from "../../images/1-table-8-chair.png";
import React, {forwardRef, useImperativeHandle, useMemo} from "react";
import axios from "axios";
import clientConfig from "../../env";
import {toast} from "react-toastify";
import {useResizeObserver} from "@mantine/hooks";
import {Link} from "react-router-dom";
import {setMyCredit} from "../../redux/user/user.actions";

const MeetingTable = forwardRef(({data, tableIndex, isLoading = true, ...props}, ref) => {
    const authToken = useSelector( state => state.user.token );
    const userCredit = useSelector((state) => state.user.mycredits);
    const email_verified = useSelector((state) => state.user.email_verified);
    const user_details = useSelector((state) => state.user);
    const userId = useSelector((state) => state.user.userId);
    const dispatch = useDispatch();

    const [tableViewRef, tableViewRect] = useResizeObserver();

    const handleJoinTable = async (tableID = data?.room_slug) => {
        if (data?.room_limit <= data?.user_count) {
            // return toast.error(`You can only join ${data?.room_limit} people at a time.`)
            return toast.error(`This table is full. Please try again later or choose another table.`)
        }
        const token = await generateToken(tableID, authToken)
        if (token.startsWith('eyJ0e')) {
            const openUrl = `${clientConfig.meetUrl}/${tableID}?jwt=${token}`;
            window.open(openUrl, "_blank");
        }
    };

    useImperativeHandle(ref, () => ({
      updateUserCreditDetails: updateUserCreditDetails,
      handleJoinTable: handleJoinTable,
    }));

    const updateUserCreditDetails = async (tableID) => {
        if (data?.user_list?.some(user => user?.id === userId)) return toast.error(
                `You have already joined this table. Please try again later or choose another table.`
            )
        try {
            if (userCredit) {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Barer ${authToken}`,
                }
                let updatedCredit = userCredit - 10;
                const data = {my_credits: updatedCredit};
                await handleJoinTable(tableID);
                await axios.post(`${clientConfig.siteUrl}wl/v1/user/${userId}`, data, {headers: headers});
                dispatch(setMyCredit(updatedCredit))
                props.handleCloseTableConfirmation();
            }
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong. Please try again later.")
        }
    }

    const tableImage = useMemo(() => {
        switch (data?.room_limit) {
            case 6:
                return Table6Member;
            case 8:
                return Table8Member;
            case 4:
                return Table4Member;
            default:
                return Table2Member;
        }
    }, [data])

    const translateX = useMemo(() => {
        switch (data?.room_limit) {
            case 6:
                return {
                    gap: tableViewRect?.width * 0.23 || 92,
                    top: tableViewRect?.height * 0.37 +'px',
                    bottom: tableViewRect?.height * 0.21 +'px',
                    sideSpace: tableViewRect?.height * 0.08 +'px',
                    translateX: tableViewRect?.width * 0.315 +'px' || `9.8rem`
                };
            case 8:
                return {
                    gap: tableViewRect?.width * 0.185 || 73,
                    top: tableViewRect?.height * 0.36 +'px',
                    bottom: tableViewRect?.height * 0.21 +'px',
                    sideSpace: tableViewRect?.height * 0.07 +'px',
                    translateX: tableViewRect?.width * 0.242 +'px' || '8.1rem'
                };
            case 4:
                return {
                  gap: null,
                  top: tableViewRect?.height * 0.37 + "px",
                  bottom: tableViewRect?.height * 0.18 + "px",
                  sideSpace: tableViewRect?.height * 0.08 + "px",
                  translateX: tableViewRect?.width * 0.42 + "px" || "12.5rem",
                };
            default:
                console.log(tableViewRect);
                return {
                    gap: null,
                    top: tableViewRect?.height * 0.37 +'px',
                    bottom: tableViewRect?.height * 0.18 +'px',
                    sideSpace: tableViewRect?.height * 0.08 +'px',
                    translateX: (tableViewRect?.width * .42) +'px' || "12.5rem"
                };
        }
        
    }, [data, tableViewRect?.width, isLoading])

    return (
      <>
        <div
          ref={tableViewRef}
          key={data?.id}
          className={`col-12 col-md-4 ${
            email_verified && !props.tableDisable ? "cursor-pointer" : ""
          }`}
          //   onDoubleClick={
          //     email_verified ? () => updateUserCreditDetails() : () => {}
          //   }
          onClick={
            email_verified && !props.tableDisable
              ? (event) => props.handleJoinTableConfirmation(data, event)
              : () => {}
          }
        >
          <div className="p-4 position-relative">
            {data?.users.map((group, groupIndex) =>
              group?.map((user, userIndex) => (
                <TableUserWrapper
                  key={user?.id}
                  top={translateX?.top}
                  bottom={translateX?.bottom}
                  left={translateX?.sideSpace}
                  right={translateX?.sideSpace}
                  avatarGap={translateX?.gap}
                  translateX={translateX?.translateX}
                  userIndex={userIndex}
                  tableIndex={groupIndex}
                >
                  <Link
                    style={{
                      width: tableViewRect?.width * 0.15 + "px" || "40px",
                      height: tableViewRect?.width * 0.15 + "px" || "40px",
                      padding: "2px",
                    }}
                    to={`/p/${user?.user_unique_key}`}
                    className="badge badge-pill position-relative d-flex align-items-center justify-content-center badge-primary avatar-wrapper"
                  >
                    <div className="userInfoTolltips">
                      <span>
                        {user?.name} {user?.lname[0]}
                      </span>
                    </div>
                    <div className="animationBackground"></div>
                    <img
                      src={
                        user?.avatar ||
                        `https://getstream.io/random_svg/?name=${
                          user?.name || ""
                        }`
                      }
                      alt={user?.name}
                      style={{
                        width: "400px",
                      }}
                      className="w-100 object-fit-cover rounded-circle"
                    />
                  </Link>
                </TableUserWrapper>
              ))
            )}
            <img
              src={tableImage}
              className="img-fluid mb-2"
              alt={data?.room_title}
              // style={{
              //   filter: props.tableDisable ? "grayscale(1)" : "none",
              // }}
            />
            <div className="font-weight-bold">{data?.room_title}</div>
          </div>
        </div>
      </>
    );
});

export default MeetingTable;

export const TableUserWrapper = ({children, tableIndex = null, left = '', right = '', top = '', bottom = '', translateX = '12.5rem', translateY = '0', avatarGap = 92, userIndex}) => {
    const userViewStyle = useMemo(() => {
        switch (tableIndex) {
            case 1:
                return {
                    right,
                    top,
                }
            case 3:
                return {
                    left,
                    top,
                }
            case 2:
                return {
                    transform: `translate(${translateX}, ${translateY || '0'})`,
                    left: `${userIndex * (avatarGap)}px`,
                    bottom: `60px`,
                }
            default:
                return {
                    transform: `translate(${translateX}, ${translateY || '0'})`,
                    left: `${userIndex * (avatarGap)}px`,
                    top: '27px',
                }
        }
    }, [avatarGap, tableIndex, translateX, translateY, userIndex])
    return (<div style={userViewStyle} className="position-absolute">{children}</div>)
}

export const generateToken = async (roomID, token = null, data = {}) =>  {
    const configheader = {
        "Content-Type": `application/json`,
    }
    if (token) {
        configheader["Authorization"] = `Bearer ${token}`
    }
    try{
        const response = await axios.post(`${clientConfig.siteUrl}wl/v1/token`, {
            ...{room: roomID},
            ...data,
        },
            {
                headers: configheader
            })
        return response?.data?.token;
    } catch (e) {
        toast.error(e?.response?.data?.message || "Something went wrong. Please try again later.")
        setTimeout(() => {
            if ([401,403].includes(e?.response?.status)) {
                // sessionStorage.removeItem("persist:root");
                // window.location.href = window.location.origin;
                return toast.error(
                    `Your session has expired. Please login again.`
                )
            }
        }, 1000)
    }
}